

document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.quiz-section');
  const resultData = {
    'roller': {
      title: 'Roller Crutch Card',
      description: 'You\'re a classic Roller—creative, practical, and always prepared. Stick with the original Roller Crutch Card.',
      link: '/products/roller'
    },
    'big-roller': {
      title: 'Big Roller Crutch Card',
      description: 'Bold, artistic, and always expressive—your roll demands the Big Roller Crutch Card. More tips, more creativity, bigger impact.',
      link: '/products/roller'
    },
    'big-promoter': {
      title: 'Big Promoter Crutch Card',
      description: 'You roll with purpose. The Big Promoter Crutch Card gives you maximum branding space and impact—exactly what your vibe demands.',
      link: '/products/promoter'
    },
    'promoter': {
      title: 'Promoter Crutch Card',
      description: 'Professional, polished, and always memorable—the Promoter Crutch Card perfectly suits your style. Compact design, big impression.',
      link: '/products/promoter'
    }
  };

  function hideAllSections() {
    sections.forEach(section => section.classList.add('hidden'));
  }

  document.querySelectorAll('[data-path]').forEach(button => {
    button.addEventListener('click', (e) => {
      const path = e.target.getAttribute('data-path');
      hideAllSections();
      document.getElementById(`${path}-path`).classList.remove('hidden');
    });
  });

  document.querySelectorAll('[data-result]').forEach(button => {
    button.addEventListener('click', (e) => {
      const resultKey = e.target.getAttribute('data-result');
      hideAllSections();
      document.getElementById('quiz-result').classList.remove('hidden');
      document.getElementById('result-title').textContent = resultData[resultKey].title;
      document.getElementById('result-description').textContent = resultData[resultKey].description;
      document.getElementById('result-link').setAttribute('href', resultData[resultKey].link);
    });
  });
});
